var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCelo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2064_7692)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.89474 18.2025C11.0926 18.2025 13.6842 15.6109 13.6842 12.413C13.6842 9.21512 11.0926 6.62354 7.89474 6.62354C4.69684 6.62354 2.10526 9.21512 2.10526 12.413C2.10526 15.6109 4.69684 18.2025 7.89474 18.2025ZM7.89474 20.3078C3.53474 20.3078 0 16.773 0 12.413C0 8.05301 3.53474 4.51828 7.89474 4.51828C12.2547 4.51828 15.7895 8.05301 15.7895 12.413C15.7895 16.773 12.2547 20.3078 7.89474 20.3078Z",
    fill: "#FBCC5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1057 13.9919C15.3036 13.9919 17.8952 11.4003 17.8952 8.20243C17.8952 5.00454 15.3036 2.41296 12.1057 2.41296C8.90778 2.41296 6.3162 5.00454 6.3162 8.20243C6.3162 11.4003 8.90778 13.9919 12.1057 13.9919ZM12.1057 16.0972C7.74567 16.0972 4.21094 12.5624 4.21094 8.20243C4.21094 3.84243 7.74567 0.307693 12.1057 0.307693C16.4657 0.307693 20.0004 3.84243 20.0004 8.20243C20.0004 12.5624 16.4657 16.0972 12.1057 16.0972Z",
    fill: "#35D07F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3667 16.0972C12.9141 15.4341 13.3057 14.6572 13.5141 13.8214C14.3478 13.613 15.1246 13.2214 15.7899 12.6741C15.7604 13.6404 15.552 14.592 15.1751 15.4846C14.2846 15.8593 13.333 16.0678 12.3667 16.0972ZM6.48673 6.79407C5.65304 7.00249 4.8762 7.39407 4.21094 7.94143C4.24041 6.97512 4.44883 6.02354 4.82567 5.13301C5.7162 4.75828 6.66989 4.54986 7.6341 4.51828C7.08673 5.18143 6.69515 5.95828 6.48673 6.79407Z",
    fill: "#5EA33B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2064_7692"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.307693)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCelo);
export default __webpack_public_path__ + "static/media/CELO.769d009831c901033b58d72ac2696b63.svg";
export { ForwardRef as ReactComponent };